import { render, staticRenderFns } from "./Scorecard.vue?vue&type=template&id=5ac5682a&scoped=true&"
import script from "./Scorecard.vue?vue&type=script&lang=js&"
export * from "./Scorecard.vue?vue&type=script&lang=js&"
import style0 from "./Scorecard.vue?vue&type=style&index=0&id=5ac5682a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5682a",
  null
  
)

export default component.exports